import React, { memo } from "react";

import { FormatInfoProps } from "./types";

export const FormatInfo: React.FC<FormatInfoProps> = memo(({ format }) => {
  if (!format) {
    return null;
  }
  return (
    <>
      <div className="hidden h-1 w-1 rounded-full bg-gray-300 sm:block" />
      <div className="text-sm text-gray-600">{format}</div>
    </>
  );
});
